/* Tikoun Aolam — header search scans ALL published products (no 4/10 cap). */
(function () {
  var GROUPS = [
    ["tehilim", "tehillim", "tilim", "תהלים", "תהילים"],
    ["sidour", "siddur", "sidur", "siddour", "סידור"],
    ["echet", "eshet", "hayil", "אשת"],
    ["selihot", "selichot", "slichot", "slihot", "slichotes", "selihoth", "sélihot", "סליחות"],
    ["phonetique", "phonetic", "phonétique", "פונטי"],
    ["mahzor", "mahzorim", "makhzor", "מחזור"],
    ["kippour", "kippur", "kipour", "כיפור"],
    ["tichri", "tishrei", "tishri", "tishré", "תשרי"],
    ["eloul", "elul", "אלול"],
    ["likoute", "likutei", "likoutey", "likutey", "ליקוטי"],
    ["roch", "rosh", "ראש"],
  ];

  function fold(s) {
    return String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/['’ʼʿ]/g, "")
      .replace(/[^a-z0-9\u0590-\u05ff]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function tokensOf(s) {
    var f = fold(s);
    return f ? f.split(" ") : [];
  }

  function expandTokens(q) {
    var toks = tokensOf(q);
    var out = {};
    toks.forEach(function (t) {
      out[t] = true;
      GROUPS.forEach(function (g) {
        var hit = g.some(function (a) {
          return fold(a) === t || fold(a).indexOf(t) === 0 || t.indexOf(fold(a)) === 0;
        });
        if (hit) {
          g.forEach(function (a) {
            out[fold(a)] = true;
          });
        }
      });
    });
    return Object.keys(out).filter(Boolean);
  }

  function blobOf(p) {
    var raw = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",");
    var tags = raw
      .map(function (t) {
        return String(t || "").trim();
      })
      .filter(function (t) {
        var f = fold(t);
        return f && !/^(nos |nouveau|bientot|בקרוב|חדש)/.test(f);
      })
      .join(" ");
    return fold([p.title, p.handle.replace(/-/g, " "), p.product_type, tags].join(" "));
  }

  function available(p) {
    var vs = p.variants || [];
    if (!vs.length) return true;
    return vs.some(function (v) {
      return v.available !== false;
    });
  }

  function imgOf(p) {
    if (p.images && p.images[0] && p.images[0].src) return p.images[0].src;
    return "";
  }

  function matchProduct(p, exp) {
    var blob = blobOf(p);
    return exp.some(function (t) {
      return t.length >= 2 && blob.indexOf(t) !== -1;
    });
  }

  var catalog = null;
  var loading = null;

  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    if (loading) return loading;
    loading = fetch("/collections/all/products.json?limit=250")
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        catalog = data.products || [];
        return catalog;
      })
      .catch(function () {
        loading = null;
        return [];
      });
    return loading;
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
  }

  function render(root, q, items) {
    var drop = root.querySelector(".ta-search-drop");
    if (!drop) return;
    if (!q || q.trim().length < 2) {
      drop.hidden = true;
      drop.innerHTML = "";
      return;
    }
    if (!items.length) {
      drop.hidden = false;
      drop.innerHTML = '<div class="ta-search-empty">Aucun livre pour « ' + esc(q) + ' »</div>';
      return;
    }
    var searchUrl = root.querySelector("form").getAttribute("action") || "/search";
    var html = items
      .map(function (p) {
        var sold = available(p) ? "" : '<span class="ta-search-sold">Épuisé</span>';
        var src = imgOf(p);
        var img = src
          ? '<img src="' + esc(src) + '" alt="" width="44" height="44" loading="lazy">'
          : "<span></span>";
        return (
          '<a class="ta-search-hit" href="/products/' +
          esc(p.handle) +
          '">' +
          img +
          '<span class="ta-search-ttl">' +
          esc(p.title) +
          sold +
          "</span></a>"
        );
      })
      .join("");
    html +=
      '<a class="ta-search-all" href="' +
      esc(searchUrl) +
      "?type=product&q=" +
      encodeURIComponent(q) +
      '">Voir les ' +
      items.length +
      " fiches</a>";
    drop.innerHTML = html;
    drop.hidden = false;
  }

  function bind(root) {
    var input = root.querySelector(".ta-search-input");
    var btn = root.querySelector(".ta-search-btn");
    if (!input) return;
    var t = null;
    function run() {
      var q = input.value || "";
      var exp = expandTokens(q);
      loadCatalog().then(function (list) {
        var hits = (list || []).filter(function (p) {
          return matchProduct(p, exp);
        });
        render(root, q, hits);
      });
    }
    input.addEventListener("input", function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    });
    input.addEventListener("focus", function () {
      root.classList.add("is-open");
      loadCatalog();
      if ((input.value || "").trim().length >= 2) run();
    });
    if (btn) {
      btn.addEventListener("click", function (e) {
        if (window.innerWidth <= 900 && !root.classList.contains("is-open")) {
          e.preventDefault();
          root.classList.add("is-open");
          input.focus();
        }
      });
    }
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) {
        root.classList.remove("is-open");
        var drop = root.querySelector(".ta-search-drop");
        if (drop) drop.hidden = true;
      }
    });
  }

  document.querySelectorAll("[data-ta-search]").forEach(bind);
})();

/* 2026-09-02 search rewrite — slichot/slihot → selihot + mois + synonymes */
(function(){
  var MAP={slichot:'selihot',slihot:'selihot',selichot:'selihot',slichotes:'selihot',selihoth:'selihot',
    siddur:'sidour',sidur:'sidour',siddour:'sidour',tehillim:'tehilim',tilim:'tehilim',
    tishrei:'tichri',tishri:'tichri',elul:'eloul',kippur:'kippour',makhzor:'mahzor'};
  function canon(q){
    var f=String(q||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    var parts=f.split(/[^a-z0-9\u0590-\u05ff]+/).filter(Boolean);
    return parts.map(function(p){return MAP[p]||p;}).join(' ');
  }
  if(location.pathname==='/search'){
    try{
      var u=new URL(location.href);
      var q=u.searchParams.get('q')||'';
      var c=canon(q);
      if(c && c!==q){ u.searchParams.set('q',c); location.replace(u.toString()); return; }
    }catch(e){}
  }
  document.addEventListener('submit',function(ev){
    var f=ev.target; if(!f||!f.querySelector) return;
    var inp=f.querySelector('input[name="q"]'); if(!inp) return;
    var c=canon(inp.value); if(c && c!==inp.value) inp.value=c;
  },true);
})();
